<template>
  <!-- 商品管理————组件 -->
  <el-dialog :title="title" :visible.sync="dialogFormVisible" :fullscreen="true" top="2vh" width="90%" @close="close"
    :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form ref="form" :model="queryForm" :inline="true" @submit.native.prevent style="padding: 0;">
      <!-- 查询 -->
      <el-form-item style="border: 1px solid #999; border-radius: 10px; ">
        <el-form-item label="规格名称">
          <el-input v-model="queryForm.name" :clearable="true" placeholder="查询规格名称" />
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" native-type="submit" @click="handleQuery"
            style="border-radius: 8px;">
            查询
          </el-button>
        </el-form-item>
      </el-form-item>
      <!-- 批量修改 -->
      <el-form-item style="border: 1px solid #999; border-radius: 10px; ">
        <el-form-item label="条形码">
          <el-input v-model="queryForm.barcode" :clearable="true" placeholder="修改条形码" />
        </el-form-item>
        <el-form-item label="备案号">
          <el-input v-model="queryForm.record" :clearable="true" placeholder="修改备案号" />
        </el-form-item>
        <el-form-item label="价格">
          <el-input v-model="queryForm.price" :clearable="true" placeholder="修改价格" style="width:120px" />
        </el-form-item>
        <el-form-item label="库存">
          <el-input v-model="queryForm.stock" :clearable="true" placeholder="修改库存" style="width:120px" />
        </el-form-item>
        <el-form-item label="限购">
          <el-input v-model="queryForm.max_buy" :clearable="true" placeholder="修改限购" style="width:120px" />
        </el-form-item>
        <el-form-item label="重量">
          <el-input v-model="queryForm.weight" :clearable="true" placeholder="修改重量" style="width:120px;" />
        </el-form-item>

        <el-form-item label="数量">
          <el-input v-model="queryForm.record_num" :clearable="true" placeholder="修改数量" style="width:120px;" />
        </el-form-item>


        <el-form-item>
          <el-button icon="el-icon-edit" type="warning" @click="modify" style="border-radius: 8px;">
            批量修改
          </el-button>
        </el-form-item>
      </el-form-item>
    </el-form>
    <!-- <div class="div_form"> -->
    <el-table :data="skuList" height="80vh" border v-loading="listLoading" :element-loading-text="elementLoadingText"
      style="width: 100%">
      <el-table-column align="left" prop="sku" label="规格名" min-width="120"></el-table-column>
      <el-table-column align="center" label="规格图" min-width="120">
        <template slot-scope="scope">
          <div style="width: 100%; display: flex; justify-content: center">
            <uploadFile :limit="1" maxlength="15" show-word-limit :img-list-string="scope.row.pic"
              @fileChange="skuListPicChange($event, scope.$index)" />
          </div>
        </template>
      </el-table-column>

      <el-table-column align="center" label="条形码" min-width="120">
        <template slot-scope="{ row }">
          <el-input v-model="row.barcode" @change="oneClickModify(row)"></el-input>
        </template>
      </el-table-column>
    <el-table-column align="center" label="备案号" min-width="120">
        <template slot-scope="{ row }">
          <el-input v-model="row.record" @change="oneClickModify(row)"></el-input>
        </template>
      </el-table-column>
      <el-table-column align="center" label="价格" min-width="120">
        <template slot-scope="{ row }">
          <el-input v-model="row.price" @input="(e) => { row.price = $geShi(e) }" maxlength="10" show-word-limit
            @change="oneClickModify(row)"></el-input>
        </template>
      </el-table-column>
      <el-table-column align="center" label="库存" min-width="120">
        <template slot-scope="{ row }">
          <el-input v-model="row.stock" maxlength="10" show-word-limit @input="(e) => { row.stock = $geShi(e) }"
            @change="oneClickModify(row)"></el-input>
        </template>
      </el-table-column>

      <el-table-column align="center" label="限购" min-width="120">
        <template slot-scope="{ row }">
          <el-input v-model="row.max_buy" maxlength="10" show-word-limit @input="(e) => { row.max_buy = $geShi(e) }"
            @change="oneClickModify(row)"></el-input>
        </template>
      </el-table-column>
      <el-table-column align="center" label="重量" min-width="120">
        <template slot-scope="{ row }">
          <el-input v-model="row.weight" size="small" maxlength="10" show-word-limit @change="oneClickModify(row)">
            <span slot="append">KG</span>
          </el-input>
        </template>
      </el-table-column>
         <el-table-column align="center" label="数量" min-width="130">
                <template slot-scope="{ row }">
                  <el-input v-model="row.record_num" size="small" maxlength="10" show-word-limit
                    @change="oneClickModify(row)">
                  </el-input>
                </template>
              </el-table-column>
    </el-table>


    <!-- </div> -->

    <el-pagination :current-page="queryForm.page" :layout="layout" :page-sizes="[20, 40, 60, 100]"
      :page-size="queryForm.limit" :total="total" @current-change="handleCurrentChange" @size-change="handleSizeChange"
      :background="background"></el-pagination>
    <!-- <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" :loading="saveLoading" @click="save">确 定</el-button>
    </div> -->
  </el-dialog>
</template>

<script>
import {
  goodsSkuList,
  goods_price,
  goodsSkuUpdate
} from '@/api/xgcApi'
import {
  getUploadUrl
} from '@/config'
import uploadFile from '@/components/uploadFileSpecification'
import {
  goodsAdd
} from '../../../api/xgcApi'
import exoprt_file from '@/utils/expor_file' // 导出excel文件
export default {
  name: 'GoodsSkuEdit',
  components: {
    uploadFile,
  },
  props: {
    // typeList: {
    //   type: Array,
    //   default: [],
    // },
  },
  data() {
    return {
      skuList: [],
      listLoading: false,
      total: 0,
      background: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      elementLoadingText: '正在加载...',
      queryForm: {
        goods_id: '',
        page: 1,
        limit: 20,
        name: '',
        kor_type: '0',
        type: '',
        price: '', //价格
        stock: '', //库存
        barcode: '', //条形码
        record: '', //备案号
        max_buy: '', //限购
        weight:'',
        record_num: ''
      },
      title: '一键改价',
      upUrl: '/index/index/file', //上传图片的接口
      dialogFormVisible: false,
      saveLoading: false
    }
  },

  methods: {
    showEdit(row) {
      if (!row) return
      this.queryForm.goods_id = row.id
      this.dialogFormVisible = true
      this.fetchData()
    },


    async fetchData() {
      this.listLoading = true
      const {
        data
      } = await goodsSkuList(this.queryForm)
      this.skuList = data.list
      this.total = data.count
      setTimeout(() => {
        this.listLoading = false
      }, 500)
    },


    handleSizeChange(val) {
      this.queryForm.limit = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    handleQuery() {
      this.queryForm.page = 1
      this.fetchData()
    },


    // 批量修改
    modify() {
      var data = {
        "goods_id": this.queryForm.goods_id, //商品id
        "kor_type": "0",
        "price": this.queryForm.price, //价格
        "stock": this.queryForm.stock, //库存
        "barcode": this.queryForm.barcode, //条形码
        "record": this.queryForm.record, //备案号
        "max_buy": this.queryForm.max_buy, //限购
        "weight":this.queryForm.weight,
        "record_num": this.queryForm.record_num //数量
      }
      this.listLoading = true
      goods_price(data)
        .then((res) => {
          this.$message.success('修改成功')
          this.queryForm.page = 1
          this.fetchData()
        })
        .catch((err) => {
          this.listLoading = false
        })
      this.queryForm.price = ''
      this.queryForm.stock = ''
      this.queryForm.barcode = ''
      this.queryForm.record = ''
      this.queryForm.max_buy = ''
      this.queryForm.weight = ''
      this.queryForm.record_num = ''
    },
    //单条数据修改
    oneClickModify(e) {
       e.record_num = String(e.record_num || '').replace(/，/g, ',')
      console.log(typeof (e.sku), '123132')
      if (typeof (e.sku) === 'string') {
        e.sku = e.sku.split(",")
      }

      var list = []
      list.push(e)
      var date = {
        id: e.gid,
        type: 0, //0表示没修改组合 1修改组合清除下面sku
        spec_list: list
      }
      this.listLoading = true
      goodsSkuUpdate(date).then(res => {
        this.listLoading = false
        this.$message.success('修改成功')
      }).catch(err => {
        this.listLoading = false
      })
    },
    // 上传、修改图片
    skuListPicChange(e, index) {
      console.log(e, '1245678')
      console.log(this.skuList[index], '12456')
      if (e.length > 0) {
        this.skuList[index].pic = e[0]
      } else {
        this.skuList[index].pic = ''
      }
      this.oneClickModify(this.skuList[index])



    },









    kor_type_change() {
      this.form.cid = null
      this.form.bid = null
      this.form.b_type_id = null
      this.getTypelist()
      index_brand({
        kor_type: this.form.kor_type
      }).then((res) => {
        this.bidList = res.data
      })

    },
    getProvinceList() {
      getCityList({ pid: 0 }).then(res => {
        this.provinceList = res.data
      })
    },
    getTypelist() {
      var data = {
        page: 1,
        kor_type: this.form.kor_type
      }
      this.listLoading = true
      GoodsCate_list(data)
        .then((res) => {
          this.typeList = res.data
        })
        .catch((err) => {
          this.listLoading = false
        })
    },














    getType_list() {
      // 获取线路
      // Index_country_list
      var data = {}
      Index_country_list(data).then(res => {
        this.countryList = res.data
      })
    },
    typeChagne(e) {
    },
    getBidList() {
      index_brand({}).then((res) => {
        this.bidList = res.data
      })
    },
    bidChange(e) {
      this.form.bid = e
      this.form.b_type_id = ''
      index_brand_types({
        brand_id: e
      }).then((res) => {
        this.brand_typeList = res.data
      })
    },
    brand_typeChange(e) {
      this.form.b_type_id = e
    },
    // 将-字符换成_
    changeInput_sku(e, index) {
      this.SpecificationsList[index].name = this.SpecificationsList[
        index
      ].name.replace(/-/g, '_')
    },
    // 将-字符换成_
    changeInput(e, index, ind) {
      this.SpecificationsList[index].item[ind].text = this.SpecificationsList[
        index
      ].item[ind].text.replace(/-/g, '_')
    },
    // t添加规格项
    addSpecifications() {
      var item = {
        name: '',
        item: [],
      }
      this.SpecificationsList.push(item)
    },

    // 添加规格项
    addSpecifications_item(index) {
      var child = {
        text: '',
      }
      this.SpecificationsList[index].item.push(child)
    },
    // 删除规格
    delSpecifications(index) {
      this.SpecificationsList.splice(index, 1)
    },
    // 删除规格项
    delSpecifications_item(index, ind) {
      this.SpecificationsList[index].item.splice(ind, 1)
    },
    // 生成SKU列表
    getSkuList() {
      return new Promise((resolve, reject) => {
        var arr = []
        var ISok = true
        if (this.SpecificationsList.length == 0) {
          ISok = false
          this.$message({
            type: 'warning',
            message: '请添加规格',
          })
          reject('err')
          return
        } else {
          ISok = true
        }
        this.SpecificationsList.forEach((item, index) => {
          var sku_item = []
          item.item.forEach((ite, ind) => {
            if (ite.text) {
              sku_item.push(ite.text)
            } else {
              ISok = false
              this.$message({
                type: 'warning',
                message: '规格项不能为空',
              })
              reject('err')
              return
            }
          })
          arr.push(sku_item)
        })
        if (!ISok) {
          return
        }
        var sku_list = []
        if (arr.length > 1) {
          var sku_list_one = this.cartesianProduct(arr)
          sku_list_one.forEach((item, index) => {
            sku_list[index] = {
              name: item.join('-'),
              sku: item,
              stock: 0,
              max_buy: 0,
              weight: 0,
              barcode: '',
              record: '',
              pic: '',
              price: 0
            }
          })
        } else {
          this.SpecificationsList[0].item.forEach((item, index) => {
            sku_list[index] = {
              name: item.text,
              sku: item,
              stock: 0,
              max_buy: 0,
              weight: 0,
              barcode: '',
              record: '',
              pic: '',
              price: 0
            }
          })
        }
        if (this.skuList.length > 0) {
          sku_list = sku_list.map((aItem) => {
            var bItem = this.skuList.find(
              (bItem) => bItem.name === aItem.name
            )
            return {
              ...aItem,
              ...bItem
            }
          })
          this.skuList = sku_list
        } else {
          this.skuList = sku_list
        }
        resolve(this.skuList)
        return
      })
    },
    // 迪卡儿积算法
    cartesianProduct(sets) {
      return sets.reduce((a, b) => {
        return a.reduce((res, aItem) => {
          return res.concat(b.map((bItem) => [].concat(aItem, bItem)))
        }, [])
      })
    },
    /**
     *@name 富文本编辑器
     *@time 2024年4月23日15:01:58
     */
    // ---------------------------富文本编辑器开始--------------------------------------
    onEditorChange(e) { },
    upload(file) {
      // 图片上传
      file = file.file
      var data = {
        file: file,
      }
      var url = ''
      exoprt_file(this.upUrl, data).then((res) => {
        var pic = getUploadUrl + res
        let quill = this.$refs.myQuillEditor.quill
        // 获取光标所在位置
        let length = quill.getSelection().index
        // 插入图片 res.url为服务器返回的图片地址
        quill.insertEmbed(length, 'image', pic)
        // 调整光标到最后
        quill.setSelection(length + 1)
        // 调用编辑器的 insertEmbed 方法，插入URL
      })
    },
    handleInput() {
      // 移除非数字和非小数点字符，保留小数点
      this.form.tax = this.form.tax
        .replace(/[^\d.]/g, '')
        // 保留第一个小数点，移除其他小数点
        .replace(/^(\d*\.)(.*)\./g, '$1$2')
        // 移除前导零，但保留小数点前的单个零
        .replace(/^0+(\d+\.{0,1}\d*)/, '$1')
    },
    // 上传图片
    uploadChange(e, key) {
      var strurl = e.join(',')
      strurl = strurl.replace('\\\\', '\/\/')
      strurl = strurl.replace('\\', '\/')
      strurl = strurl.replace('\\', '\/')
      this.form[key] = strurl
    },


    close() {
      this.skuList = []
      this.queryForm.page = 1
      this.queryForm.limit = 20
      this.queryForm.name = ''
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {


          console.log(this.form, '9999')


          this.saveLoading = true
          console.log(this.getSkuList(), '121231321')




          this.getSkuList().then((res) => {
            var spec_submit = JSON.parse(
              JSON.stringify(this.SpecificationsList)
            )

            console.log(spec_submit, '98989888')




            spec_submit.forEach((value, index) => {
              spec_submit[index].item_text = []
              value.item.forEach((ite, ind) => {
                spec_submit[index].item_text.push(ite.text)
              })
              spec_submit[index].item = spec_submit[index].item_text
              delete spec_submit[index].item_text
            })
            var spec_list = JSON.parse(JSON.stringify(this.skuList))
            spec_list.forEach((item, index) => {
              delete spec_list[index].name
            })
            // this.form.content = this.value
            this.form.spec = spec_submit
            this.form.spec_list = spec_list

            if (this.form.remote_city.length > 0 && this.form.remote_price == '') {
              this.$message.warning('请输入偏远地区运费价格')
              return
            }

            console.log(this.isShow, '852147')


            if (this.isShow == false) {
              var form = JSON.parse(JSON.stringify(this.form))



              console.log(this.form, 'this.form')
              console.log(form, 'form')

              form.cid = this.form.cid.join(',')
              form.remote_city = this.form.remote_city.join(',')
              goodsAdd(form).then(res => {
                this.$baseMessage(res.msg, 'success')
                this.$emit('fetch-data')
                this.close()
                this.saveLoading = false
              })



            } else {
              var form = JSON.parse(JSON.stringify(this.form))
              form.remote_city = this.form.remote_city.join(',')
              var submit_sku = JSON.parse(JSON.stringify(form.spec_list))
              // 获取删除的skuid
              var old_id = [] //没有被改变的sku
              var old_all_sku_id = [] //最开始的skuid
              submit_sku.forEach((item, index) => {
                if (item.id) {
                  old_id.push(item.id)
                }
              })
              this.skuList_copy.forEach((item, index) => {
                if (item.id) {
                  old_all_sku_id.push(item.id)
                }
              })
              var delID = []
              if (old_id.length > 0) {
                delID = old_all_sku_id.filter(item => !old_id.includes(item));
              } else {
                delID = old_all_sku_id
              }
              delID = delID.join(',')
              form.spec_list_del = delID
              // =====================
              this.$refs['form'].validate(async (valid) => {
                if (valid) {
                  form.cid = this.form.cid.join(',')
                  form.kor_type = String(this.form.kor_type)
                  try {
                    const { msg } = await goodsUpdate(form)
                    this.saveLoading = false
                    this.$baseMessage(msg, 'success')
                    this.$emit('fetch-data')
                    this.close()
                  } catch (error) {
                    // 错误处理
                    this.saveLoading = false
                  }
                } else {
                  this.saveLoading = false
                  return false
                }
              })
            }
          }).catch((err) => {
            this.saveLoading = false
          })




        } else {
          return false
          this.saveLoading = false
        }
      })



















    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-dialog__body {
  padding-top: 0px;
  padding-bottom: 0px;
}

::v-deep .el-form-item--small.el-form-item {
  margin: 10px;
}

.guige_item {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 15px;
  margin-bottom: 20px;
}

.guige_item_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.guige_item_bottom {
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

:deep .el-input--small .el-input__inner {
  width: 100%;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding-right: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/*  :deep .el-dialog__body {
    height: 63vh;
    overflow: hidden;
    overflow-y: scroll;
  } */
// .div_form {
//   height: 80vh;
//   overflow: hidden;
//   overflow-y: scroll;
// }

:deep .ql-container {
  height: 400px;
}
</style>
